export default __webpack_public_path__ + "static/media/Mountain@3x.7dbb0dc6.png";